@let activeState = widget()?.settings?.options?.orders?.activeState;

@if (activeState === optionOrderStateEnum.CANCELED) {
	<app-dropdown-columns-actions
		[columns]="canceledColumns()"
		[translationPrefix]="'optionsOrders.'"
		(columnsChange)="onChangeCanceledColumns($event)"
	/>
} @else if (activeState === optionOrderStateEnum.OPEN) {
	<app-dropdown-columns-actions
		[columns]="openColumns()"
		[translationPrefix]="'optionsOrders.'"
		(columnsChange)="onChangeOpenColumns($event)"
	/>
} @else if (activeState === optionOrderStateEnum.FILLED) {
	<app-dropdown-columns-actions
		[columns]="filledColumns()"
		[translationPrefix]="'optionsOrders.'"
		(columnsChange)="onChangeFilledColumns($event)"
	/>
}
